import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Settings = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="max-h-[calc(100dvh-4rem)] w-full overflow-y-auto bg-neutral-100 dark:bg-neutral-900">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white dark:bg-neutral-900 border-b border-neutral-200 dark:border-neutral-800">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center">
          <button 
            onClick={() => navigate('/profile')}
            className="p-2 mr-2 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-xl font-semibold">{t('settings.title')}</h1>
        </div>
      </div>
      
      {/* Coming Soon Message */}
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-32">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('settings.comingSoon')}</h2>
          <p className="text-neutral-600 dark:text-neutral-400 max-w-lg mx-auto">
            {t('settings.description')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Settings;